export default __webpack_public_path__ + "static/media/game-catg-5.39a8db3d.jpg";